export default __webpack_public_path__ + "static/media/bg_body4.91e6423d.jpg";